export const MAX_RECEIPTS_PER_ENTITY = 5;

export function validateMaxReceiptCount(args: {
  existingCount: number;
  incomingCount: number;
  max?: number;
}): { ok: true } | { ok: false; max: number } {
  const max = args.max ?? MAX_RECEIPTS_PER_ENTITY;
  const total = args.existingCount + args.incomingCount;
  if (total > max) return { ok: false, max };
  return { ok: true };
}

export function buildReceiptUploadFormData(args: {
  files: FileList | File[];
  existingAssetIds?: Array<string | number>;
}): FormData {
  const formData = new FormData();

  const filesArray = Array.isArray(args.files)
    ? args.files
    : Array.from(args.files);
  for (const file of filesArray) {
    formData.append("receipts", file);
  }

  if (args.existingAssetIds && args.existingAssetIds.length > 0) {
    formData.append("assetIds", args.existingAssetIds.join(","));
  }

  return formData;
}

/**
 * Re-wrap the package's `File[]` as a `FileList`.
 *
 * The upload paths take a FileList because that is what an `<input type=file>`
 * hands over, and the package hands back an array. Converting here keeps the
 * five call sites from each building their own DataTransfer.
 */
export const toFileList = (files: File[]): FileList => {
  const transfer = new DataTransfer();
  files.forEach((file) => transfer.items.add(file));
  return transfer.files;
};
